/**
 * Centralized route configuration
 * Unified structure with route and label together
 */

// Route configuration with both path and label
export const ROUTE_CONFIG = {
  LOGIN: { path: '/login', label: 'login' },
  LOGIN_SSO: { path: '/loginsso', label: 'login sso' },
  FORGOT_USERKEY: { path: '/forgot-userkey', label: 'esqueci minha senha' },
  UNAUTHORIZED: { path: '/unauthorized', label: 'não autorizado' },
  HOME: { path: '/', label: 'home' },
  HOME_ALT: { path: '/home', label: 'home' },
  PREVIDENCIA: { path: '/previdencia', label: 'previdência' },
  SAUDE: { path: '/saude', label: 'saúde' },
  VIDA: { path: '/vida', label: 'vida' },
  PROFILE: { path: '/profile', label: 'perfil' },
  REGISTER_POLICEHOLDER: { path: '/registerpoliceholder', label: 'Cadastro de Representante' },
  COMPANY: { path: '/company', label: 'empresa' },
  MESSAGE: { path: '/message', label: 'mensagem' },
  WEB_VIDA: { path: '/webvida', label: 'webvida' },
  MANAGEMENT: { path: '/management', label: 'manutenção' },
  REPORTS: { path: '/reports', label: 'relatórios' },
} as const;

// Extract just the paths for backward compatibility
export const ROUTES = Object.fromEntries(
  Object.entries(ROUTE_CONFIG).map(([key, config]) => [key, config.path])
) as Record<keyof typeof ROUTE_CONFIG, string>;

// Content types derived from route paths
export type ContentType = typeof ROUTE_CONFIG[keyof typeof ROUTE_CONFIG]['path'];

// Helper functions
export const getRouteLabel = (path: string): string => {
  const routeEntry = Object.values(ROUTE_CONFIG).find(config => config.path === path);
  return routeEntry?.label || 'home';
};

// Simple function to normalize home routes
export const normalizeContentType = (path: string): ContentType => {
  return path === '/home' ? ROUTE_CONFIG.HOME.path : (path as ContentType);
};
